import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  dialog: {
    '& h6': {
      margin: '0',
    },
    '& .add-to-billing-group-dialog-dropdown': {
      marginBottom: '80px',
    },
    '& .ms-Dialog-main': {
      minWidth: '450px',
    },
  },
});
